import { render, staticRenderFns } from "./BuildingDialog.vue?vue&type=template&id=c2a77b72"
import script from "./BuildingDialog.vue?vue&type=script&lang=js"
export * from "./BuildingDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports